import { Component, OnInit, NgModule, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxToolbarModule } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
import { CoreModule } from 'src/app/core/core.module';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
  standalone: false
})
export class PublicHeaderComponent implements OnInit, OnChanges {
  @Input() hederInfo: any;
  getIMG: string;
  currentTitle = '';
  @Input() isShowImgLogo: boolean;
  isSubRoutInfo: Subscription;
  routCID: number;
  constructor(private route: ActivatedRoute) {
    this.isSubRoutInfo = this.route.queryParams
      .subscribe(params => {
        if (params.cid !== undefined) {
          this.routCID = parseInt(atob(params.cid));
        }
      });
  }

  ngOnInit() {
  }
  ngOnChanges() {
    this.isShowImgLogo = this.isShowImgLogo;
    if (this.hederInfo && this.hederInfo.custLogoURL) {
      this.getIMG = this.hederInfo.custLogoURL;
      this.currentTitle = this.hederInfo.customerTitle;
    } else if (this.hederInfo && this.hederInfo.logoURL) {
      this.getIMG = this.hederInfo.logoURL;
      this.currentTitle = this.hederInfo.customerTitle;
    } else if (this.routCID > 0) {
    } else {
      this.isShowImgLogo = false;
    }
  }
}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    DxToolbarModule,
    CoreModule
  ],
  declarations: [PublicHeaderComponent],
  exports: [PublicHeaderComponent]
})
export class PublicHeaderModule { }
